import { apiClient } from "./ApiClient";
import { ICoverageConfig } from "../classes/Domain";

export default class CoveragesApiClient {

    getCoverageConfigs(quoteUid: string) {
        return apiClient.instance.request({
            url: '/quote/coverages/configs',
            data: {
                uid: quoteUid
            }
        });
    }

    getRates(quoteUid: string, coverageConfig: ICoverageConfig) {
        return apiClient.instance.request({
            url: '/quote/get-rate',
            data: {
                uid: quoteUid,
                coverageConfig
            }
        });
    }
}